import { onApiError } from "../error";
import { locale } from "../locale";
import { state } from "../state";
import { get } from "./client";

/**
 * @typedef {Object} Prices
 * @property {Price} FarmcamSimExtraData
 * @property {Price} FarmcamSimSmall
 * @property {Price} FarmcamSimMedium
 * @property {Price} FarmcamSimLarge
 * @property {Price} FencealarmMonth
 * @property {Price} FencealarmYear
 * @property {Price} Fencealarm2Month
 * @property {Price} Fencealarm2Year
 * @property {Price} SmartplugMonth
 * @property {Price} SmartplugYear
 * @property {Price} Smartplug2Month
 * @property {Price} Smartplug2Year
 * @property {Price} Sms
 * 
 * @typedef {Object} Price
 * @property {string} Id
 * @property {string} Name
 * @property {number} Eur
 * @property {number} Sek
 * @property {() => Promise<string>} toString
 */

/**
 * DEPRECATED in favour of billing/prices.js
 * @returns {Promise<Prices>}
 */
async function getPrices() {
    if (!getPricesCache) {
        const res = await get("/prices", {
            timeout: 20000,
        })

        if (!res.ok) throw onApiError(res)
        getPricesCache = await res.json()
    }

    if (!getPricesCache) throw "failed to get price data"

    /** @type {Prices} */
    Object.entries(getPricesCache).forEach(([key, price]) => {
        price.toString = async () => {
            const currency = (await state.getActiveUser()).Country === "SE" ? "Sek" : "Eur"

            const perMonthString = locale.string({
                enGB: "per month ex VAT",
                deDE: "pro Monat ohne MwSt.",
                frFR: "par mois hors TVA",
                svSE: "per månad ex moms",
            })

            const perYearString = locale.string({
                enGB: "per year ex VAT",
                deDE: "pro Jahr ohne MwSt.",
                frFR: "par an hors TVA",
                svSE: "per år ex moms",
            })

            switch (key) {
                case "FarmcamSimSmall":
                case "FarmcamSimMedium":
                case "FarmcamSimLarge":
                case "FencealarmMonth":
                case "Fencealarm2Month":
                case "SmartplugMonth":
                case "Smartplug2Month":
                    return `${price[currency]} ${currency.toUpperCase()} ${perMonthString}`
                case "FencealarmYear":
                case "Fencealarm2Year":
                case "SmartplugYear":
                case "Smartplug2Year":
                    return `${price[currency]} ${currency.toUpperCase()} ${perYearString}`
                case "FarmcamSimExtraData":
                case "Sms":
                    return `${price[currency]} ${currency.toUpperCase()}`
                default:
                    return `0 ${currency.toUpperCase()}`
            }
        }
    })

    return getPricesCache
}

/** @type {Prices|undefined} */
let getPricesCache

export {
    getPrices,
}